import { createRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import { AtlasDataProvider } from "./components/atlas-data-provider";
import { createAtlasQueryClient } from "./lib/query-client";
import { withSentry } from "./lib/sentry-browser";
import { routeTree } from "./routeTree.gen";
import { parseAtlasSearch, stringifyAtlasSearch } from "./lib/navigation-target";

export function getRouter() {
  const query = createAtlasQueryClient();
  const router = createRouter({
    routeTree,
    context: query,
    Wrap: ({ children }) => <AtlasDataProvider {...query}>{children}</AtlasDataProvider>,
    parseSearch: parseAtlasSearch,
    stringifySearch: stringifyAtlasSearch,
    scrollRestoration: true,
    // Access is rechecked on every navigation; private loader data is not kept
    // for later visits after a membership or sign-in change.
    defaultPreload: false,
    defaultStaleTime: 0,
    defaultGcTime: 0,
  });
  setupRouterSsrQueryIntegration({ router, queryClient: query.queryClient, wrapQueryClient: false });
  if (typeof window !== "undefined") {
    withSentry((sentry) => sentry.addIntegration(sentry.tanstackRouterBrowserTracingIntegration(router)));
  }
  return router;
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
